import React from 'react';
import { Route, Switch } from 'react-router';
import CustomerList from './scenes/List';

const CustomerRouter = ({ match }) => {
  return (
    <Switch>
      <Route path='/dashboard/crm/customers' exact component={CustomerList} />
    </Switch>
  );
};

export default CustomerRouter;
